import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Container, Content, Hero, HeroBody, Title } from 'bloomer'

import Head from '../../components/head'
import Layout from '../../components/layout'
import Link from '../../components/link'

const toKebabCase = string =>
  string &&
  string
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x.toLowerCase())
    .join('-')

class Tags extends Component {
  render() {
    const allTags = this.props.data.allMarkdownRemark.group

    return (
      <Layout location={this.props.location}>
        <Head
          title={`Route Nation Tags`}
          description={`All Route Nation Blog Tags for different categories of content.`}
          keywords={['route', 'route nation', 'blog', 'tags']}
          {...this.props}
        />
        <Hero isSize={'large'}>
          <HeroBody>
            <Container hasTextAlign={`centered`}>
              <Title isSize={1}>Tags</Title>
              <ul>
                {allTags.map(tag => (
                  <li key={tag.fieldValue} style={{ margin: '1rem auto' }}>
                    <Content isSize={'large'}>
                      <Link
                        style={{ textDecoration: `none` }}
                        to={`/route-nation/tags/${toKebabCase(tag.fieldValue)}`}
                      >
                        {tag.fieldValue} ({tag.totalCount})
                      </Link>
                    </Content>
                  </li>
                ))}
              </ul>
            </Container>
          </HeroBody>
        </Hero>
      </Layout>
    )
  }
}

export default Tags

export const tagsQuery = graphql`
  query TagsQuery {
    allMarkdownRemark(filter: { frontmatter: { draft: { ne: true } } }) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
  }
`
